var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 10,
    fill: "#1787FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.172 17.172C17 18.343 17 20.229 17 24V28C17 31.771 17 33.657 18.172 34.828C19.344 35.999 21.229 36 25 36H27C30.771 36 32.657 36 33.828 34.828C34.999 33.656 35 31.771 35 28V24C35 20.229 35 18.343 33.828 17.172C32.656 16.001 30.771 16 27 16H25C21.229 16 19.343 16 18.172 17.172ZM22 23.25C21.8011 23.25 21.6103 23.329 21.4697 23.4697C21.329 23.6103 21.25 23.8011 21.25 24C21.25 24.1989 21.329 24.3897 21.4697 24.5303C21.6103 24.671 21.8011 24.75 22 24.75H30C30.1989 24.75 30.3897 24.671 30.5303 24.5303C30.671 24.3897 30.75 24.1989 30.75 24C30.75 23.8011 30.671 23.6103 30.5303 23.4697C30.3897 23.329 30.1989 23.25 30 23.25H22ZM22 27.25C21.8011 27.25 21.6103 27.329 21.4697 27.4697C21.329 27.6103 21.25 27.8011 21.25 28C21.25 28.1989 21.329 28.3897 21.4697 28.5303C21.6103 28.671 21.8011 28.75 22 28.75H27C27.1989 28.75 27.3897 28.671 27.5303 28.5303C27.671 28.3897 27.75 28.1989 27.75 28C27.75 27.8011 27.671 27.6103 27.5303 27.4697C27.3897 27.329 27.1989 27.25 27 27.25H22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseDoc);
export default __webpack_public_path__ + "static/media/case_doc.8c2ee9d66563c5fe80cab2f5281ee24a.svg";
export { ForwardRef as ReactComponent };